import { getApiConfigSafe } from './api-config';

export const truncateDecimals = (num: number, decimals: number = 4) => {
    const factor = Math.pow(10, decimals);
	return Math.round(num * factor) / factor;
};

export function calculateAdditionalDiscountCrossValue(
  sourceValue: number,
  sourceField: 'percentage' | 'amount',
  total: number,
  decimals: number = 2,
  useTruncation: boolean = false
): number {
  if (total <= 0 || sourceValue <= 0) return 0;
  if (sourceField === 'percentage') {
    const result = total * (sourceValue / 100);
    if (getApiConfigSafe()?.countryEnv === 'ksa') return result;
    return useTruncation ? truncateDecimals(result, decimals) : Number(result.toFixed(decimals));
  }
  const result = (sourceValue / total) * 100;
  if (getApiConfigSafe()?.countryEnv === 'ksa') return result;
  return useTruncation ? truncateDecimals(result, decimals) : Number(result.toFixed(decimals));
}

export const calculateEntries = (
	items: any[],
	expenses?: any[],
	additionalDiscountOn?: string,
	additionalDiscountPercentage?: number,
	providedAdditionalDiscountAmount?: number,
	roundOff?: boolean,
	roundOffAmount?: number,
  promotionAmount?: number,
  decimals: number = 2,
  useTruncation: boolean = false
) => {
	let totalQuantity = 0,
		totalDiscount = 0,
		totalTaxAmount = 0,
		totalAmountExcludingAll = 0,
		totalAmountIncludingAll = 0,
		additionalDiscountAmount = 0,
		totalGrossAmount = 0;

	if (items.length) {
		items.forEach((item) => {
			totalQuantity += Number(item?.quantity || 0);
			totalDiscount += Number(item?.discount_amount || 0);
			totalAmountIncludingAll += Number(
				item.total_amount || 0
			);
			totalTaxAmount += Number(item.tax_amount);
			totalAmountExcludingAll +=
				Number(item.quantity || 0) *
				Number(item.rate || 0);
			totalGrossAmount += Number(item.gross_amount || 0);
		});
	}
	if (expenses?.length) {
		expenses.forEach((item) => {
			totalQuantity += 1;
			totalDiscount += Number(item.discount_amount || 0);
			totalAmountIncludingAll += Number(
				item.total_amount || 0
			);
			totalTaxAmount += Number(item.tax_amount);
			totalAmountExcludingAll += 1 * Number(item.rate);
			totalGrossAmount += Number(item.gross_amount || 0);
		});
	}

	let finalAmount = totalAmountIncludingAll;

	if (additionalDiscountOn) {
		if (additionalDiscountOn === 'Net Amount') {
			if (
				additionalDiscountPercentage &&
				Number(additionalDiscountPercentage) !== 0
			) {
				additionalDiscountAmount =
					totalAmountIncludingAll * (additionalDiscountPercentage / 100);
			} else {
				additionalDiscountAmount = providedAdditionalDiscountAmount || 0;
			}
		} else if (additionalDiscountOn === 'Gross Amount') {
			if (
				additionalDiscountPercentage &&
				Number(additionalDiscountPercentage) !== 0
			) {
				additionalDiscountAmount =
					totalGrossAmount * (additionalDiscountPercentage / 100);
			} else {
				additionalDiscountAmount = providedAdditionalDiscountAmount || 0;
			}
		}
	}

	finalAmount =
		additionalDiscountOn === 'Gross Amount'
			? Number(totalAmountIncludingAll) - Number(additionalDiscountAmount)
			: Number(totalAmountIncludingAll) - Number(additionalDiscountAmount);
  
  if(Number(promotionAmount)) {
    finalAmount = finalAmount - Number(promotionAmount)
  }

	const actualTotalAmount = finalAmount;
	if (roundOff && roundOffAmount && Number(roundOffAmount)) {
		finalAmount = Math.round(finalAmount / roundOffAmount) * roundOffAmount;
	}
	const roundOffDifference = Number(finalAmount) - Number(actualTotalAmount);
	const totalItemsExpenseDiscount = totalDiscount;
	totalDiscount += Number(additionalDiscountAmount);
	return {
		totalQuantity,
		totalDiscount,
		totalItemsExpenseDiscount,
		totalTaxAmount,
		totalAmountExludingAll: totalAmountExcludingAll,
		totalAmountIncludingAll,
		additinoalDiscountAmount: additionalDiscountAmount,
		totalGrossAmount,
		actualTotalAmount,
		roundOffDifference,
		finalAmount
	};
};